import React, { useDeferredValue, useState } from 'react';

import { findRouterByName } from '../../helpers/find-router-by-name';

import { createRouterContext, useRouterContext } from './context';
import type { IProps } from './models';

/** Компонент, управляющий роутами */
export const Router = <S,>({ children, defaultRoute, name }: IProps<S>) => {
    const Context = createRouterContext<S>();
    const parentRouter = useRouterContext();
    const [route, setRoute] = useState<S>(defaultRoute);
    const deferredRoute = useDeferredValue<S>(route);

    /**
     * @param nextRoute имя роута на который нужно переключить
     * @param routerName имя роутера в котором нужно найти nextRoute
     * @returns роут с которого перешли
     */
    const switchRoute = (nextRoute: S, routerName?: string) => {
        /** Имя роутера передано и оно не совпадает с текущим */
        if (routerName && routerName !== name) {
            const foundRouter = findRouterByName(parentRouter, routerName);
            foundRouter?.switchRoute(nextRoute as string);

            return deferredRoute;
        }
        setRoute(nextRoute);

        return deferredRoute;
    };

    return (
        <Context.Consumer>
            {parent => {
                return (
                    <Context.Provider
                        value={{
                            name,
                            route,
                            parent,
                            switchRoute,
                        }}
                    >
                        {children}
                    </Context.Provider>
                );
            }}
        </Context.Consumer>
    );
};
